import React from "react";
import i18n from "../../../../../../constants/i18n";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";
import { TalkhattabatConversationType } from "../../../../../../Types";
import Et3Image from "../../../../../../core/et3-Image";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import { isPositiveNumber, reduce } from "et3-type-guards";
import OneOTwoMessagesCounters from "./OneOTwoMessagesCounter";
import OneOTwoQuality from "./OneOTwoQuality";

const ConverstionStates = withLiteObserverAndTheme<{
  exitedByMatch: boolean;
  exitedByClient: boolean;
  exitedByClientDate: Date;
  exitedByMatchDate: Date;
  pendingInteraction: boolean;
  conversationID: string;
  conversationType: TalkhattabatConversationType;
  clientConversationID: string;
  oneOTwoConversationId: string;
  clientID: number
}>((props) => {
  const {
    exitedByClient,
    exitedByMatch,
    exitedByClientDate,
    exitedByMatchDate,
    pendingInteraction,
    conversationID,
    conversationType,
    clientConversationID,
    oneOTwoConversationId,
    clientID,
    theme
  } = props;
  const { colors } = theme;

  const isOneOTwoConversation = conversationType === "102";
  const {
    conversationStatuskey,
    conversationStatusImageName,
    conversationExitDate
  } = getKhattabatStore().getConversationHeaderStatusValues({
    exitedByClient,
    exitedByMatch,
    exitedByClientDate,
    exitedByMatchDate,
    pendingInteraction
  });

  const conversationIsOpenState = reduce(
    () => getKhattabatStore().conversationsProps.get(conversationID).isOpened,
    "CLOSED"
  );
  const isConversationOpen = conversationIsOpenState === "OPENED";
  const arrowImageName = isConversationOpen ? "up-arrow" : "down-arrow";
  const isPendingOrOngoingConversation = isPositiveNumber(
    ["PENDING_INTERACTION", "ONGOING"].indexOf(conversationStatuskey),
    true
  );

  return (
    <ET3Div
      width={0}
      height={45}
      alignItems={"center"}
      fDirection={"row"}
      style={{ width: "auto" }}
      color={""}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => { }}
    >
      {isOneOTwoConversation ? (
        <React.Fragment>
          <OneOTwoQuality
            clientConversationID={clientConversationID}
            oneOTwoConversationId={oneOTwoConversationId}
            clientID={clientID}
          />
          <Et3Margin top={0} bottom={0} left={5} right={5} />
          <OneOTwoMessagesCounters
            clientConversationID={clientConversationID}
            oneOTwoConversationId={oneOTwoConversationId}
          />
          <Et3Margin top={0} bottom={0} left={5} right={5} />
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={24}
            isSpan={false}
            text={i18n.get(conversationStatuskey)}
            style={{}}
            color={colors.all.black}
          />
          <Et3Margin top={0} bottom={0} left={5} right={5} />
          <Et3Image
            type="LOCAL"
            alt={i18n.get("USER")}
            imageName={conversationStatusImageName}
            size={18}
            onClick={() => { }}
            style={{}}
          />
          <Et3Margin top={0} bottom={0} left={5} right={5} />
          {isPendingOrOngoingConversation ? null : (
            <Et3Text
              fontFamily={"MEDIUM"}
              fontSize={24}
              isSpan={false}
              text={`${conversationExitDate}`}
              style={{}}
              color={colors.all.black}
            />
          )}
          <Et3Margin top={0} bottom={0} left={5} right={5} />
        </React.Fragment>
      ) : null}
      <ET3Div
        width={30}
        height={45}
        alignItems={"center"}
        fDirection={"row"}
        style={{ cursor: "pointer" }}
        color={""}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() => {
          getKhattabatStore().updateConversationProp({
            conversationID,
            propKey: "isOpened",
            value: ""
          });
        }}
      >
        <Et3Image
          type="LOCAL"
          alt={i18n.get("USER")}
          imageName={arrowImageName}
          size={24}
          onClick={() => { }}
          style={{}}
        />
      </ET3Div>
      <Et3Margin top={0} bottom={0} left={10} right={10} />
    </ET3Div>
  );
});

export default ConverstionStates;
